var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"joinus-container"},[_c('module1'),_c('module2',{ref:"join2"}),_c('module3',{ref:"join3"}),_c('module4',{ref:"join4"}),_c('module5',{ref:"join5"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }